blue.ready('ariaLables', 'input, textarea, select', input => {
	let id = input.getAttribute('id')
	
	if(id !== null && id.indexOf('"') == -1) {
		id = '"' + id + '"'
	}

	let label = document.querySelector(`[for=${id}]`)
	let ariaLabel

	if (label) {
		ariaLabel = label.textContent
	}
	else {
		ariaLabel = input.getAttribute('placeholder') ? input.getAttribute('placeholder') : input.getAttribute('name') ? input.getAttribute('name') : ''
	}
	
	if (input.getAttribute('aria-label') && input.getAttribute('aria-label').trim.length == 0) {
		input.setAttribute('aria-label', ariaLabel)
	} 
})